import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
    // {
    //     path: '/',
    //     name: 'GetAccess',
    //     component: () => import('@/components/basecamp/GetAccess.vue'),
    // },
    // {
    //     path: '/',
    //     name: 'GetAccess',
    //     component: () => import('@/components/dropbox/GetAccess.vue'),
    // },
    //{
    //    path: '/oauth',
    //    name: 'OAuth',
    //    component: () => import('@/components/basecamp/OAuth.vue'),
    //},
    {
        path: '/:idproject',
        name: 'ExternalHomePage',
        component: () => import('@/components/pages/ExternalHomePage.vue'),
        meta: {
            title: 'Oppaiman Dashboard'
        }
    },
    // {
    //     path: '/dashboard-render',
    //     name: 'StaticRenderPage',
    //     component: () => import('@/components/pages/StaticRenderPage.vue'),
    // },
    {
        path: '/:idproject/dashboard-production',
        name: 'ProductionPage',
        component: () => import('@/components/pages/ProductionPage.vue'),
    },
    {
        path: '/:idproject/dashboard-speed',
        name: 'VelocityPage',
        component: () => import('@/components/pages/VelocityPage.vue'),
    },
    {
        path: '/:idproject/dashboard-production/:date',
        name: 'ProductionDetailsPage',
        component: () => import('@/components/pages/ProductionDetailsPage.vue'),
    },
    {
        path: '/:idproject/dashboard-buffer',
        name: 'BufferPage',
        component: () => import('@/components/pages/BufferPage.vue'),
    },
    {
        path: '/:idproject/dashboard-buffer/:date',
        name: 'BufferDetailsPage',
        component: () => import('@/components/pages/BufferDetailsPage.vue'),
    },
    {
        path: '/:idproject/approvals',
        name: 'ApprovalsPage',
        component: () => import('@/components/pages/ApprovalsPage.vue'),
    },
    {
        path: '/:idproject/animations',
        name: 'AnimationsPage',
        component: () => import('@/components/pages/AnimationsPage.vue'),
    },
    {
        path: '/:idproject/scene',
        name: 'ScenePage',
        component: () => import('@/components/pages/ScenePage.vue'),
    },
    {
        path: '/:idproject/episodepartial',
        name: 'EpisodePartialPage',
        component: () => import('@/components/pages/EpisodePartialPage.vue'),
    },
    {
        path: '/:idproject/paprika-dashboard',
        name: 'PaprikaDashboardPage',
        component: () => import('@/components/pages/PaprikaDashboardPage.vue'),
    },
    {
        path: '/:idproject/character',
        name: 'CharacterPage',
        component: () => import('@/components/pages/CharacterPage.vue'),
    },  
    {
        path: '/:idproject/clothing',
        name: 'ClothingPage',
        component: () => import('@/components/pages/ClothingPage.vue'),
    },  
    {
        path: '/:idproject/statistics',
        name: 'StatisticsPage',
        component: () => import('@/components/pages/StatisticsPage.vue'),
    },  
    {
        path: '/:idproject/scenery',
        name: 'SceneryPage',
        component: () => import('@/components/pages/SceneryPage.vue'),
    },  
    {
        path: '/:idproject/user/:id',
        name: 'UserPage',
        component: () => import('@/components/pages/UserPage.vue'),
    },
    {
        path: '/:idproject/unsubscriber',
        name: 'UnsubscriberPage',
        component: () => import('@/components/pages/UnsubscriberPage.vue'),
    },
    {
        path: '/:idproject/config',
        name: 'ExternalConfigurationPage',
        component: () => import('@/components/pages/ExternalConfigurationPage.vue'),
    },
    {
        path: '/:idproject/unauthorized',
        name: 'UnauthorizedPage',
        component: () => import('@/components/pages/UnauthorizedPage.vue'),
    },
    {
        path: '/:idproject/404',
        name: 'NotFoundPage',
        component: () => import('@/components/pages/NotFoundPage.vue'),
    },
    {
        path: '/:idproject/:pathMatch(.*)',
        redirect: to => ({
            name: "NotFoundPage",
            params: {idproject: to.params.idproject}
        })
    },

];

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
  });
  
  export default router;